import React, { useState } from 'react';
import FormService from '../services/FormService';
import './FeedbackPage.css';

const FeedbackPage = () => {
  const [formData, setFormData] = useState({
    type: 'suggestion', // suggestion, bug, other
    message: '',
    email: '' // Optional
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    // Clear error when typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.message.trim()) newErrors.message = 'נא לכתוב את המשוב שלך';
    
    if (formData.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'כתובת אימייל לא תקינה';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Fire and forget - don't wait for response
      FormService.submitForm('Feedback Form', formData)
        .catch(error => console.error('Error submitting feedback (background):', error));
        
      setSubmitted(true);
    }
  };

  if (submitted) {
    return (
      <div className="feedback-page">
        <div className="feedback-card success">
          <div className="success-icon"><i className="fi fi-rr-sparkles"></i></div>
          <h2>תודה על המשוב!</h2>
          <p>הדעה שלך חשובה לנו ועוזרת לנו להשתפר.</p>
          <button 
            className="btn btn-secondary"
            onClick={() => {
              setSubmitted(false);
              setFormData({ type: 'suggestion', message: '', email: '' });
            }}
          >
            שליחת משוב נוסף
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="feedback-page">
      <div className="feedback-card">
        <div className="feedback-header">
          <h2>תיבת הצעות ומשוב</h2>
          <p>יש לך רעיון לשיפור? מצאת באג? נשמח לשמוע!</p>
        </div>

        <form onSubmit={handleSubmit} className="feedback-form" noValidate>
          <div className="form-group">
            <label className="form-label">סוג המשוב</label>
            <div className="type-selector">
              <label className={`type-option ${formData.type === 'suggestion' ? 'active' : ''}`}>
                <input 
                  type="radio" 
                  name="type" 
                  value="suggestion" 
                  checked={formData.type === 'suggestion'} 
                  onChange={handleChange}
                />
                <span><i className="fi fi-rr-bulb"></i> רעיון/הצעה</span>
              </label>
              <label className={`type-option ${formData.type === 'bug' ? 'active' : ''}`}>
                <input 
                  type="radio" 
                  name="type" 
                  value="bug" 
                  checked={formData.type === 'bug'} 
                  onChange={handleChange}
                />
                <span><i className="fi fi-rr-bug"></i> דיווח על באג</span>
              </label>
              <label className={`type-option ${formData.type === 'other' ? 'active' : ''}`}>
                <input 
                  type="radio" 
                  name="type" 
                  value="other" 
                  checked={formData.type === 'other'} 
                  onChange={handleChange}
                />
                <span><i className="fi fi-rr-edit"></i> אחר</span>
              </label>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="message" className="form-label">ההודעה שלך</label>
            <textarea
              id="message"
              name="message"
              autoComplete="off"
              value={formData.message}
              onChange={handleChange}
              placeholder="כתבו כאן את המשוב שלכם..."
              rows={6}
              className={`feedback-textarea ${errors.message ? 'input-error' : ''}`}
            />
            {errors.message && <span className="error-message">{errors.message}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="email" className="form-label">אימייל (אופציונלי - אם תרצו שנחזור אליכם)</label>
            <input
              type="email"
              id="email"
              name="email"
              autoComplete="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your@email.com"
              className={`feedback-input ${errors.email ? 'input-error' : ''}`}
              dir="ltr"
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>

          <button type="submit" className="btn btn-primary btn-lg btn-full">
            שליחת משוב
          </button>
        </form>
      </div>
    </div>
  );
};

export default FeedbackPage;
